module.exports = __webpack_public_path__ + "static/media/water.4a6a5d12.svg";